import { accountTypes } from 'config/user.type.constants'
import { useMemo, useState } from 'react'
import { Modal, MultiSelect } from 'stories/components'
import { filterObject } from 'utils'

import { IActiveUser } from './type'

export const DownloadAllActivityModal = ({
  users,
  onClose,
  onDownload,
}: {
  users: IActiveUser[]
  onClose: () => void
  onDownload: (excludeUserIds: string[], excludeAccountTypes: string[]) => void
}) => {
  const [excludeUsers, setExcludeUsers] = useState<Record<string, boolean>>({})
  const [excludeProfiles, setExcludeProfiles] = useState<Record<string, boolean>>({})

  const userOptions = useMemo(() => {
    const options: Record<string, string> = {}
    users.forEach((user) => {
      options[String(user.id)] = user.email
    })
    return options
  }, [users])

  const onSubmit = () => {
    onDownload(filterObject(excludeUsers), filterObject(excludeProfiles))
  }

  return (
    <Modal title="Download All User Activity" titleOkay="Download CSV" onClose={onClose} onOk={onSubmit} isOpen>
      <div className="text-gray-900 w-144">
        <p className="text-sm text-gray-600 mb-4">
          Export activity for all users matching the current filters. Optionally exclude specific users or profiles
          below.
        </p>
        <div className="grid gap-4">
          <MultiSelect
            id="exclude-users"
            title="Exclude Users"
            options={userOptions}
            value={excludeUsers}
            defaultOptionText="None"
            hasDefaultOption
            defaultSelected={false}
            onChange={setExcludeUsers}
          />
          <MultiSelect
            id="exclude-profiles"
            title="Exclude Profiles"
            options={accountTypes}
            value={excludeProfiles}
            defaultOptionText="None"
            hasDefaultOption
            defaultSelected={false}
            onChange={setExcludeProfiles}
          />
        </div>
      </div>
    </Modal>
  )
}
